export enum InvoicingVewPageContentEnum {
  ORDER_LINES = 'order-lines',
  INVOICES_AND_CREDIT_NOTES = 'invoices-and-credit-notes'
}
export const InvoicingVewPageContentEnumList = [
  InvoicingVewPageContentEnum.ORDER_LINES,
  InvoicingVewPageContentEnum.INVOICES_AND_CREDIT_NOTES,
];
